import { PortalThunk, portalAction } from '..'
import { TagsRequest } from '../../model'

export const postTag: PortalThunk<TagsRequest, void> = portalAction(
  'tags/post',
  async (request, thunk) => await thunk.extra.portalApi().post('/portal/consumers/tags', request)
)

export const updateTag: PortalThunk<TagsRequest, void> = portalAction(
  'tags/update',
  async (request, thunk) => await thunk.extra.portalApi().put('/portal/consumers/tags', request)
)
